import { useParams } from "react-router-dom"
import GLWDHomePage from "./HomePage/GLWDHomePage"
import GuideAndFAQPage from "./GuideAndFAQ/GuideAndFAQPage"
import PrivacyPolicy from "./PrivacyPolicy/PrivacyPolicy"
import TermsAndConditions from "./TermsAndConditions/TermsAndConditions"
import ShippingAndDelivery from "./ShippingAndDelivery/ShippingAndDelivery"
import { useStore } from "../../Utils/utils"
import VentorHomePage from "./HomePage/VentorHomePage"
import HomePage from "../HomePage/HomePage"


export default function PageDetails() {
    var { id } = useParams()
    const { store, setStore } = useStore()
    return(
        <>
        {id==1?store?.sub_domain=='glwd'?<GLWDHomePage/>:<HomePage/>:id==2?<GuideAndFAQPage/>:id==3?<ShippingAndDelivery/>:id==4?<PrivacyPolicy/>:<TermsAndConditions/>
        }
        </>
    )
}